<template>
	<b-row class="scroller-container m-0">
		<b-col class="p-0">
			<b-row v-if="count > 0" class="m-0">
				<b-col :class="`controls text-right p-0${(count == 1 ? ' disabled' : '')}`">
					<icon @click="onPreviousClick" name="caret-left" scale="1.2" class="mr-1"></icon>
					<div class="count">{{currentIndex + 1}} / {{count}}</div>
					<icon @click="onNextClick" name="caret-right" scale="1.2" class="ml-1"></icon>
				</b-col>
			</b-row>
			<b-row class="m-0">
				<b-col v-if="count > 0" ref="text" class="text text-right p-0" v-html="data[currentIndex]"></b-col>
				<b-col v-else ref="text" class="text no-data-text text-right p-0" v-html="noDataText"></b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
	export default {
		name: 'TextScroller',
		props: {
			data: null,
			noDataText: null
		},
		data: function () {
			return {
				index: 0
			}
		},
		mounted: function () {
			this.startAutoScroll()
		},
		destroyed: function () {
			this.endAutoScroll()
		},
		computed: {
			count: function () {
				return this.data.length
			},
			currentIndex: function () {
				return this.index
			}
		},
		methods: {
			onPreviousClick: function () {
				this.endAutoScroll()
				this.decrement()

				this.$store.dispatch(
					"Timeouts/set",
					{
						name: "ScrollerPreviousClick",
						callback: this.startAutoScroll(),
						timeout: 500
					})
			},
			onNextClick: function () {
				this.endAutoScroll()
				this.increment()

				this.$store.dispatch(
					"Timeouts/set",
					{
						name: "ScrollerNextClick",
						callback: this.startAutoScroll(),
						timeout: 500
					})
			},
			decrement: function () {
				if (this.count > 1)
					this.$refs.text.style.opacity = 0

				var $this = this

				this.$store.commit("Timeouts/clear", "ScrollerDecrement")
				this.$store.dispatch(
					"Timeouts/set",
					{
						name: "ScrollerDecrement",
						callback: function () {
							$this.$refs.text.style.opacity = 1
							$this.index = $this.currentIndex == 0 ? $this.count - 1 : $this.currentIndex - 1
						},
						timeout: 500
					})
			},
			increment: function () {
				if (this.count > 1)
					this.$refs.text.style.opacity = 0

				var $this = this

				this.$store.commit("Timeouts/clear", "ScrollerIncrement")
				this.$store.dispatch(
					"Timeouts/set",
					{
						name: "ScrollerIncrement",
						callback: function () {
							$this.$refs.text.style.opacity = 1
							$this.index = $this.currentIndex == $this.count - 1 ? 0 : $this.currentIndex + 1
						},
						timeout: 500
					})
			},
			startAutoScroll: function () {
				var $this = this

				if (this.count > 1) {
					this.$store.dispatch("Intervals/set", { name: "Scroller", callback: () => { $this.increment() }, timeout: 10000 })
				}
				else {
					this.endAutoScroll()
				}
			},
			endAutoScroll: function () {
				this.$store.commit("Timeouts/clear", "ScrollerPreviousClick")
				this.$store.commit("Timeouts/clear", "ScrollerNextClick")
				this.$store.commit("Timeouts/clear", "ScrollerDecrement")
				this.$store.commit("Timeouts/clear", "ScrollerIncrement")
				this.$store.commit("Intervals/clear", "Scroller")
			}
		}
	}
</script>

<style scoped>
	.scroller-container {
		user-select: none;
	}

		.scroller-container .controls {
			font-size: 12px;
		}

			.scroller-container .controls.disabled {
				color: #bfbfbf;
				cursor: default;
			}

			.scroller-container .controls svg {
				margin-bottom: -5px;
				cursor: pointer;
			}

			.scroller-container .controls.disabled svg {
				cursor: default;
			}

			.scroller-container .controls .count {
				display: inline-block;
				vertical-align: middle;
				font-size: 15px;
				font-weight: bold;
			}

		.scroller-container .text {
			overflow: visible;
			direction: rtl;
			color: #E33838;
			-webkit-transition: all 0.5s ease-in;
			-moz-transition: all 0.5s ease-in;
			-ms-transition: all 0.5s ease-in;
			-o-transition: all 0.5s ease-in;
			transition: all 0.5s ease-in;
		}

		.scroller-container .no-data-text {
			color: #c4c4c4;
		}
</style>